import TagCard from './src'

TagCard.install = Vue => {
  Vue.component(TagCard.name, TagCard)
}

export default TagCard
